import { useEffect } from "react";
import { AppLayout } from "@/components/layout/AppLayout";
import { IaChat } from "@/components/IaChat";
import { useDemoStore } from "@/store/useDemoStore";

export default function InstructorIa() {
  const setRole = useDemoStore((s) => s.setRole);
  useEffect(() => setRole("instructor"), [setRole]);
  return (
    <AppLayout pageTitle="Asistente IA · Instructor" breadcrumb={["Instructor", "Asistente IA"]}>
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        <IaChat role="instructor" />
      </div>
    </AppLayout>
  );
}
